import Hero from "../components/newHomePage/Hero";
 
import Navbar from "../components/homepage/Navbar";
import { Header, Footer } from "../shared";

const NewHome = () => {
  return (
    <>
      <Header />
      <Hero />
      <Footer />
    </>
  );
};

export default NewHome;
